import { healthResponseSchema, type HealthResponse } from '@firegame/shared';
import { request } from './client.js';

/** Interroge l'etat de sante de l'API et de ses dependances. */
export function fetchHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return request<HealthResponse>('/health', healthResponseSchema, {
    method: 'GET',
    timeoutMs: 5000,
    ...(signal ? { signal } : {}),
  });
}
